import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "user-booking-metrics" }
const _hoisted_2 = { class: "stat-card" }
const _hoisted_3 = { class: "stat-value" }
const _hoisted_4 = {
  key: 0,
  class: "stat-unit"
}
const _hoisted_5 = { class: "stat-card" }
const _hoisted_6 = { class: "stat-value" }

import { computed, toRef } from 'vue';
import { useUserBookingMetrics } from '../composables/useUserBookingMetrics.js';


export default {
  __name: 'UserBookingMetrics',
  props: {
  bookings: {
    type: Array,
    default: () => [],
  },
},
  setup(__props) {

const props = __props;

const {
  formattedAverageDuration,
  formattedBookingsPerActiveDay,
  hasDurationMetric,
} = useUserBookingMetrics(toRef(props, 'bookings'));

const durationUnit = computed(() => (hasDurationMetric.value ? 'Min.' : ''));

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createTextVNode(_toDisplayString(_unref(formattedAverageDuration)) + " ", 1 /* TEXT */),
        (durationUnit.value)
          ? (_openBlock(), _createElementBlock("small", _hoisted_4, _toDisplayString(durationUnit.value), 1 /* TEXT */))
          : _createCommentVNode("v-if", true)
      ]),
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "stat-label" }, [
        _createTextVNode(" Ø Buchungsdauer "),
        _createElementVNode("i", {
          class: "fas fa-info-circle ms-1",
          title: "Durchschnittliche Dauer aktiver (nicht stornierter) Buchungen im Zeitraum"
        })
      ], -1 /* CACHED */))
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(formattedBookingsPerActiveDay)), 1 /* TEXT */),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "stat-label" }, [
        _createTextVNode(" Ø Buchungen / aktiver Tag "),
        _createElementVNode("i", {
          class: "fas fa-info-circle ms-1",
          title: "Aktive Buchungen geteilt durch die Anzahl eindeutiger Starttage (Europe/Berlin)"
        })
      ], -1 /* CACHED */))
    ])
  ]))
}
}

}